import React from 'react';
import { SxProps, Theme } from '@mui/material';
import Mono from './Mono';

interface SectionLabelProps {
  children?: React.ReactNode;
  /** 10px is the sidebar/drawer scale, 11px the panel scale. */
  size?: 10 | 11;
  color?: string;
  /** Pin to one mode instead of following the theme. */
  light?: boolean;
  sx?: SxProps<Theme>;
}

/**
 * Uppercase mono rubric that heads a region — "VERSION HISTORY", "UPLOADING",
 * "PEOPLE WITH ACCESS". The wide tracking is what keeps it legible at 10px.
 */
export const SectionLabel: React.FC<SectionLabelProps> = ({
  children,
  size = 11,
  color,
  light,
  sx,
}) => (
  <Mono
    size={size}
    weight={600}
    color={color}
    light={light}
    letterSpacing={size === 10 ? '0.12em' : '0.1em'}
    sx={sx}
  >
    {children}
  </Mono>
);

export default SectionLabel;
